import React, { useEffect, useState } from "react";
import { Button } from '../../ui/button';
import {
  callKycDocuments,
  deleteKycReport,
  setIsVisible,
  setPageOne,
  setPageSecond,
  setRecordShow,
} from "./KycDocSlice";
import { useDispatch, useSelector } from "react-redux";
import Vpagination from "../../sharedfiles/Vpagination";
import No__Data__Found from "../Common/table/NoDataFound";
import Tooltips from "../Common/Tooltip";
import Skelton from "../Common/skeleton/Skeleton";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { exportPDFC } from "../../sharedfiles/pdfExport";
import { getDateTimeFormate } from "../../sharedfiles/helper";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";

const KycDocuments = () => {
  const dispatch = useDispatch();
  const { kycDocuments, isVisible, pageOne, pageSecond, recordShow } =
    useSelector((state) => state.KycDocumentsSlice);
  const [selectedImage, setSelectedImage] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const userId = localStorage.getItem("userId");
  const viewOnlyuser = useSelector((state) => state.dashboard.viewOnlyuser);
  const tHeader = [
    [
      "ID",
      "Document Type",
      "Document Name",
      "Document ID",
      "Name",
      "DOB",
      "Status",
      "Uploaded Date & Time",
      "Actions",
    ],
  ];

  const tooltipInfo = [
    "Unique identifier for the KYC document entry",
    "Type of the KYC document (e.g., ID Proof, Address Proof)",
    "Name of the document (e.g., National ID, Passport)",
    "Unique number of the document",
    "Name of the individual associated with the document",
    "Date of birth of the individual",
    "Current status of the document (e.g., Approved)",
    "Date and time when the document was uploaded",
    "Actions available for the document (e.g., View, Delete)",
  ];
  const kycDocumentsExportPDF = () => {
    const title = "KYC Documents Report";

    const tBody =
      kycDocuments.data && kycDocuments.data.length > 0
        ? kycDocuments.data.map((doc) => [
          doc.id || "-",
          doc.docType || "-",
          doc.docName || "-",
          doc.docId || "-",
          doc.firstName && doc.lastName
            ? `${doc.firstName} ${doc.lastName}`
            : "-",
          doc.dob ? getDateTimeFormate(doc.dob) : "-",
          doc.docStatus || "-",
          getDateTimeFormate(doc.updatedDate) || "-",
          "-",
        ])
        : [];

    exportPDFC(title, tHeader, tBody);
  };
  const payload = {
    status: "KYC_PASSED",
  };
  useEffect(() => {
    dispatch(callKycDocuments(userId, pageOne - 1, 25, payload));
  }, [dispatch]);

  const callPageApi = (pageOne, pageSecond) => {
    dispatch(setIsVisible(false));
    dispatch(callKycDocuments(userId, pageOne - 1, pageSecond, payload));
  };
  const handleDelete = (id) => {
    dispatch(deleteKycReport(id));
  };

  const handleView = (doc) => {
    setSelectedImage(doc.docPath);
    setOpenDialog(true);
  };

  const onClose = () => {
    setOpenDialog(false);
  };

  const kycDocRowAccessors = [
    (document) => (document.id ? document.id : "-"),
    (document) => (document.docType ? document.docType : "-"),
    (document) => (document.docName ? document.docName : "-"),
    (document) => (document.docId ? document.docId : "-"),
    (document) => (document.firstName && document.lastName ? `${document.firstName} ${document.lastName}` : "-"),
    (document) => (document.dob ? getDateTimeFormate(document.dob) : "-"),
    (document) => (
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${document.docStatus === "KYC_PASSED" ? "bg-green-100 text-green-800" :
        document.docStatus === "REJECTED" ? "bg-red-100 text-red-800" :
          "bg-yellow-100 text-yellow-800"
        }`}>
        {document.docStatus ? document.docStatus : "-"}
      </span>
    ),
    (document) => getDateTimeFormate(document.updatedDate) || "-",
    (document) => (
      <Button
        type="button"
        onClick={() => handleView(document)}
        variant="default"
        size="sm"
        disabled={viewOnlyuser}
      >
        View
      </Button>
    ),
  ];
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences("kycDocumentsKycDocumemts", tHeader[0]);

  return (
    <>
      <Dialog open={openDialog} onOpenChange={setOpenDialog}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold">KYC Document Preview</DialogTitle>
          </DialogHeader>
          <div className="flex justify-center items-center bg-muted rounded-lg p-4 flex-1 overflow-y-auto" style={{ minHeight: "400px", userSelect: "text" }}>
            <img src={selectedImage} alt="KYC Document" className="max-w-full max-h-full rounded" />
          </div>
        </DialogContent>
      </Dialog>
      <div className="CMS-tabs-panel">
        {!isVisible ? (
          <Skelton vLen={5} hLen={7} />
        ) : (
          <>
            <div>
              <h2 className="text-lg font-semibold text-foreground">KYC Documents</h2>
              <p className="text-sm text-muted-foreground mt-1">View and manage KYC verification documents</p>
            </div>
            <div id="result" className="py-4">
              <Vpagination
                data={kycDocuments.data}
                totalRecords={kycDocuments.totalRecords}
                paginationFirstValue={pageOne}
                paginationSecondValue={pageSecond}
                setPaginationFirstValue={setPageOne}
                setPaginationSecondValue={setPageSecond}
                recordsShow={recordShow}
                setRecordsShow={setRecordShow}
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                csvData={kycDocuments.data}
                exportPDF={kycDocumentsExportPDF}
                callApi={callPageApi}
                csvFileName={"KYC Documents Report"}
                reloadRequired={false}
                columns={allColumns}
                onToggle={toggleVisibility}
                onReorder={reorder}
                onReset={resetToDefault}
              />
            </div>
            <div className="relative rounded-lg border bg-muted/30 overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b bg-muted/50">
                    {visibleIndices.map((origIdx) => (
                      <th key={origIdx} className="px-4 py-3 text-left text-sm font-semibold text-foreground">
                        <div className="flex items-center justify-between gap-2">
                          <span>{tHeader[0][origIdx]}</span>
                          <Tooltips info={`${tooltipInfo[origIdx]}`} />
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {kycDocuments &&
                    kycDocuments.data &&
                    kycDocuments.data.length > 0 ? (
                    kycDocuments.data.map((document, index) => (
                      <tr key={index} className="border-b hover:bg-muted/50 transition-colors">
                        {visibleIndices.map((origIdx) => (
                          <td key={origIdx} className="px-4 py-3 text-sm text-foreground">
                            {kycDocRowAccessors[origIdx](document)}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <No__Data__Found colspan={visibleIndices.length} />
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default KycDocuments;